export default __webpack_public_path__ + "static/media/E.43a45700.svg";